const ITEMS = [
  "World-Famous Fried Artichokes",
  "Hand-Built Deli Sandwiches",
  "Biscoff & Yemeni Chai Lattes",
  "Dutch Crunch Everything",
  "Breakfast Burritos ’til 10:30",
  "Fresh Castroville Artichokes",
];

export default function Marquee() {
  return (
    <div
      data-testid="marquee-strip"
      className="relative z-10 -my-3 -rotate-1 scale-[1.03] overflow-hidden border-y-4 border-gold/50 bg-deep py-4 shadow-xl"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {ITEMS.map((t) => (
              <span
                key={`${dup}-${t}`}
                className="flex items-center whitespace-nowrap font-editorial text-lg italic text-gold"
              >
                <span className="px-7">{t}</span>
                <span className="text-gold/40">★</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
